import request from "@/axios";
// ----- 本地数据 ------

/** 获取分页 */
export const getActiveGoodsLocalList = params => {
  return request({
    url: "/lebo-member/web/member/doudian/localCdkey/page",
    method: "get",
    params
  });
};

/** 新增激活码商品 */
export const addActiveGoodsLocal = data => {
  return request({
    url: "/lebo-member/web/member/doudian/localCdkey/saveOrUpdate",
    method: "post",
    data
  });
};

/** 删除激活码商品 */
export const deleteActiveGoodsLocal = id => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/delById`,
    method: "get",
    params: {
      id
    }
  });
};

/** 获取详情的接口 */
export const getActiveGoodsLocalDetail = id => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/getById`,
    method: "get",
    params: {
      id
    }
  });
};

/** 提交审核的接口 */
export const submitAuditActiveGoodsLocal = id => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/submit`,
    method: "post",
    data: {
      id
    }
  });
};

/** 审核通过 */
export const auditPassActiveGoodsLocal = data => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/review`,
    method: "post",
    data: {
      id: data.id,
      reviewDescr: data.reviewDescr,
      isPass: 1,
    }
  });
};

/** 审核不通过 */
export const auditNotPassActiveGoodsLocal = data => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/review`,
    method: "post",
    data: {
      id: data.id,
      reviewDescr: data.reviewDescr,
      isPass: 0,
    }
  });
};

/** 撤销审核 */
export const cancelAuditActiveGoodsLocal = id => {
  return request({
    url: `/lebo-member/web/member/doudian/localCdkey/recall/${id}`,
    method: "put",
  });
};

/** 查看操作日志 */
export const getActiveGoodsLocalLog = params => {
  return request({
    url: `/lebo-member/web/member/operation-log/page`,
    method: "get",
    params: {
      ...params,
      module: '5'
    }
  });
};

// ---- 线上数据 ----
/** 获取分页 */
export const getActiveGoodsOnlineList = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkey/page",
    method: "get",
    params
  });
};
//^ ^--------------初始化数据-------------^ ^
/** 获取激活码会员列表 */
export const getActiveMemberList = () => {
  return request({
    url: "/lebo-member/web/member/type/listByType",
    method: "get",
    params: {
      type: 0
    }
  });
};

/** 获取激活码商品列表 */
export const getActiveGoodsList = () => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkey/list",
    method: "get",

  });
};

/** 获取联合会员商品列表 */
export const getUniteGoodsList = () => {
  return request({
    url: "/lebo-member/web/union-member/goods/base",
    method: "get",

  });
};
